<template>
  <div
    class="bags-component "
    :class="{ notincluded: !included, added: added }"
    @click="changestatus"
  >
    <div class="bags-component-container">
      <img
        v-if="added"
        class="close-button"
        src="/img/icons/add_white.svg"
        alt=""
      />
      <div class="flex">
        <img
          v-if="included"
          class="self-start"
          :src="`/img/icons/${extra.icon}`"
          alt=""
        />
        <img
          v-if="!included && !added"
          class="add-icon self-start"
          src="/img/icons/add_white.svg"
          alt=""
        />
        <img
          v-if="added"
          class="self-start"
          :src="`/img/icons/${extra.icon}`"
          alt=""
        />
        <div class="flex flex-row justify-between">
          <div class="text-bags flex flex-col ml-6">
            <h4 class="font-bold">{{ extra.name }}</h4>
            <p class="pr-3">{{ extra.description }}</p>
          </div>
          <div class="price-contianer">
            <p v-if="included" class="price-included self-end">
              <i class="material-icons self-center" style="font-size: 18px"
                >done</i
              ><span class="ml-1">{{$t('shared.included')}}</span>
            </p>
            <p v-if="!included && !added" class="price self-end">
              + {{ extra.price | currency }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NIGHTS_TOGGLE_PASSENGER_BAG } from "../../../store/nights/mutation-types";

export default {
  props: {
    extra: {
      type: Object,
      required: true
    },
    passenger: {
      type: Object,
      required: true
    }
  },
  computed: {
    included() {
      return this.extra.included || this.extra.price == 0;
    },
    added() {
      return this.passenger.bags.find(
        ({ description }) => description === this.extra.description
      );
    }
  },
  methods: {
    changestatus() {
      this.$emit("handleClick", {
        included: this.included,
        passengerId: this.passenger.id,
        bagId: this.extra.id
      });
      // if(!this.included){
      //   this.$store.commit(NIGHTS_TOGGLE_PASSENGER_BAG, {
      //     passengerId: this.passenger.id,
      //     bagId: this.extra.id,
      //   });
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.bags-component {
  border-radius: 15px;
  margin-bottom: 1rem;
  &-container {
    padding: 1rem;
    .price-contianer {
      width: 40%;
      display: flex;
      justify-content: flex-end;
    }
  }
  .price {
    font-weight: 900;
    display: flex;
    &-included {
      color: #00adbc;
    }
  }
  h4 {
    font-size: 20px;
  }
  p {
    font-size: 16px;
  }
  &.notincluded {
    background-color: #f1f2f8;
    cursor: pointer;
    .add-icon {
      background-color: #7e7e7e;
      border-radius: 50%;
    }
    &:hover {
      background-color: #e6e7ed;
      .add-icon {
        background-color: #00adbc;
      }
    }
  }
  &.added {
    background-color: unset !important;
    position: relative;
    .close-button {
      position: absolute;
      right: 16px;
      top: 16px;
      background-color: #7e7e7e;
      border-radius: 50%;
      transform: rotate(45deg);
    }
    &:hover {
      .close-button {
        background-color: #00adbc;
      }
    }
  }
}
</style>
